<template>
  <div class="wrapper">
    <Background />
    <Calc />
  </div>
</template>

<script>
import Background from '@/components/Background.vue';
import Calc from '@/components/Calc.vue';


export default {
  name: 'App',
  components: {
    Background,
    Calc,
  },
};
</script>


<style>
  :root {
    font: 1rem/1.5 "Exo 2", sans-serif;
  }
  *{
    box-sizing:border-box;
    margin:0;
    padding:0;
  }
  .wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100vh;
  }
</style>
